import { KienlongPayClient } from "@/api/kienlong_pay_http_client";
import { FeeReportRepository } from "../FeeReportRepository";
import {
  MonthlyFeeReportModel,
  MonthlyFeeReportStatus,
} from "@/models/FeeModel";
import {
  mapMonthlyFeeReportModel,
  mapSettlementFeeDtoToMonthlyFeeReportModel,
  mapSettlementFeeDetailResponseToMonthlyFeeReportModel,
} from "@/adapters/fee_report_adapter";
import { ErrorModel } from "@/models/ErrorModel";
import { PageTransactionResponseModel } from "@/models/PageTransactionModel";
import { TransactionResponseModel } from "@/models/TransactionModel";
import { mapTransacionResponseModel } from "@/adapters/transaction_adapter";

export class FeeReportRepositoryImp implements FeeReportRepository {
  private client: KienlongPayClient;
  constructor(kienlongPayClient: KienlongPayClient) {
    this.client = kienlongPayClient;
  }

  public async getReportFeeMerchant({
    fromDate,
    toDate,
    page,
    size,
    sort,
    status,
  }: {
    fromDate: string;
    toDate: string;
    page?: number;
    size?: number;
    sort?: string[];
    status?: MonthlyFeeReportStatus;
  }): Promise<{
    pageNumber: number;
    pageSize: number;
    totalSize: number;
    totalPage: number;
    items: Array<MonthlyFeeReportModel>;
    totalMoney: number;
  }> {
    try {
      let resp =
        await this.client.feeReportController.portalGetListSettlementFee({
          status,
          fromDate,
          toDate,
          page,
          size,
          sort,
        });
      if (resp.data.code === 0) {
        return {
          items:
            resp.data.data?.feeReports?.items?.map((d) =>
              mapSettlementFeeDtoToMonthlyFeeReportModel(d),
            ) ?? [],
          pageNumber: resp.data.data?.feeReports?.pageNumber ?? 0,
          pageSize: resp.data.data?.feeReports?.pageSize ?? 0,
          totalPage: resp.data.data?.feeReports?.totalPage ?? 0,
          totalSize: resp.data.data?.feeReports?.totalSize ?? 0,
          totalMoney: resp.data.data?.totalMoney ?? 0,
        };
      } else {
        throw new ErrorModel({
          code: resp.data.code,
          message: resp.data.message,
        });
      }
    } catch (error) {
      throw error;
    }
  }

  public async getReportFeeDetail({
    id,
  }: {
    id: string;
  }): Promise<MonthlyFeeReportModel> {
    try {
      // API mới yêu cầu id là string
      // Convert từ number sang string để gọi API
      const idString = String(id);
      let resp =
        await this.client.feeReportController.portalGetDetailSettlementFee({
          id: idString,
        });
      if (resp.data.code === 0) {
        return mapSettlementFeeDetailResponseToMonthlyFeeReportModel(
          resp.data.data,
        );
      } else {
        throw new ErrorModel({
          code: resp.data.code,
          message: resp.data.message,
        });
      }
    } catch (error) {
      throw error;
    }
  }

  public async paymentReportFeeDetail({ id }: { id: number }): Promise<string> {
    try {
      let resp = await this.client.feeReportController.payFeeMerchant({ id });
      if (resp.data.code === 0) {
        return resp.data.data?.payLinkUrl ?? "";
      } else {
        throw new ErrorModel({
          code: resp.data.code,
          message: resp.data.message,
        });
      }
    } catch (error) {
      throw error;
    }
  }

  public async exportReportPortal({
    fromDate,
    toDate,
    status,
  }: {
    fromDate: string;
    toDate: string;
    status?: MonthlyFeeReportStatus;
  }): Promise<File> {
    try {
      let resp =
        await this.client.feeReportController.portalExportSettlementFee(
          {
            status,
            fromDate,
            toDate,
          },
          { responseType: "arraybuffer" },
        );
      return resp.data;
    } catch (error) {
      throw error;
    }
  }

  public async exportReportPortalById({ id }: { id: string }): Promise<File> {
    try {
      let resp =
        await this.client.feeReportController.portalExportSettlementFee1(
          { id },
          { responseType: "arraybuffer" },
        );
      return resp.data;
    } catch (error) {
      throw error;
    }
  }

  public async getTransactionFeeReportPortal({
    feeReportId,
    page,
    size,
    sort,
  }: {
    feeReportId?: string;
    page?: number;
    size?: number;
    sort?: string[];
  }): Promise<PageTransactionResponseModel> {
    try {
      if (!feeReportId) {
        throw new ErrorModel({
          code: -1,
          message: "feeReportId is required",
        });
      }
      let resp = await this.client.feeReportController.portalGetTransactionsFee(
        {
          id: feeReportId,
          page,
          size,
          sort,
        },
      );
      if (resp.data.code === 0) {
        return {
          pageNumber: resp.data.data?.pageNumber ?? 0,
          pageSize: resp.data.data?.pageSize ?? 0,
          totalPage: resp.data.data?.totalPage ?? 0,
          totalSize: resp.data.data?.totalSize ?? 0,
          items:
            resp.data.data?.items?.map((d): TransactionResponseModel => {
              return mapTransacionResponseModel(d);
            }) ?? [],
        };
      } else {
        throw new ErrorModel({
          code: resp.data.code,
          message: resp.data.message,
        });
      }
    } catch (error) {
      throw error;
    }
  }

  public async exportTransactionFeeReportPortal({
    id,
  }: {
    id: string;
  }): Promise<File> {
    try {
      let resp =
        await this.client.feeReportController.portalExportTransactionFee(
          { id },
          { responseType: "arraybuffer" },
        );
      return resp.data;
    } catch (error) {
      throw error;
    }
  }
}
